import RestClient from '../../../../api/axiosInterceptor';
import { patientCaptchaActions } from '../../../actions/user/patient/captcha';

/**
 * Google reCAPTCHA Verification Middleware
 * Similar to the helper function but using Redux
 * @param {string} captchaValue - The reCAPTCHA token from the frontend
 * @param {function} toastCallback - Optional callback for toast notifications
 * @returns {Promise<object>} - Returns a promise with status and success info
 */
export const patientVerifyCaptcha =
	(captchaValue, toastCallback = null) =>
	  async (dispatch) => {
	    dispatch({ type: patientCaptchaActions.VERIFY_CAPTCHA.REQUEST });

	    try {
	      const response = await RestClient.post(
	        '/recaptcha/verify/',
	        { captchaValue },
	        {
	          headers: {
	            'Content-Type': 'application/x-www-form-urlencoded'
	          }
	        }
	      );

	      dispatch({
	        type: patientCaptchaActions.VERIFY_CAPTCHA.SUCCESS,
	        payload: response.data
	      });

	      if (toastCallback && response.data.success === false) {
	        toastCallback(
	          'error',
	          response.data?.message || 'Invalid reCAPTCHA. Please try again.'
	        );
	      }

	      return {
	        success: response.data.success === true,
	        status: response.status,
	        data: response.data
	      };
	    } catch (error) {
	      const errorMessage =
				error.response?.data?.message ||
				'An error occurred while verifying reCAPTCHA.';

	      dispatch({
	        type: patientCaptchaActions.VERIFY_CAPTCHA.FAILURE,
	        payload: errorMessage
	      });

	      if (toastCallback) {
	        toastCallback('error', errorMessage);
	      }

	      return {
	        success: false,
	        status: error.response?.status || 500,
	        error: errorMessage
	      };
	    }
	  };
